const buttonOutlined: object = {
  white: {
    border: "border border-white",
    color: "text-white",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-white/50",
    active: "active:opacity-[0.85]",
  },
  "blue-gray": {
    border: "border border-blue-gray-500",
    color: "text-blue-gray-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-blue-gray-200",
    active: "active:opacity-[0.85]",
  },
  gray: {
    border: "border border-gray-500",
    color: "text-gray-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-gray-200",
    active: "active:opacity-[0.85]",
  },
  brown: {
    border: "border border-brown-500",
    color: "text-brown-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-brown-200",
    active: "active:opacity-[0.85]",
  },
  "deep-orange": {
    border: "border border-deep-orange-500",
    color: "text-deep-orange-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-deep-orange-200",
    active: "active:opacity-[0.85]",
  },
  orange: {
    border: "border border-orange-500",
    color: "text-orange-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-orange-200",
    active: "active:opacity-[0.85]",
  },
  amber: {
    border: "border border-amber-500",
    color: "text-amber-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-amber-200",
    active: "active:opacity-[0.85]",
  },
  yellow: {
    border: "border border-yellow-500",
    color: "text-yellow-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-yellow-200",
    active: "active:opacity-[0.85]",
  },
  lime: {
    border: "border border-lime-500",
    color: "text-lime-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-lime-200",
    active: "active:opacity-[0.85]",
  },
  "light-green": {
    border: "border border-light-green-500",
    color: "text-light-green-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-light-green-200",
    active: "active:opacity-[0.85]",
  },
  green: {
    border: "border border-green-500",
    color: "text-green-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-green-200",
    active: "active:opacity-[0.85]",
  },
  teal: {
    border: "border border-teal-500",
    color: "text-teal-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-teal-200",
    active: "active:opacity-[0.85]",
  },
  cyan: {
    border: "border border-cyan-500",
    color: "text-cyan-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-cyan-200",
    active: "active:opacity-[0.85]",
  },
  "light-blue": {
    border: "border border-light-blue-500",
    color: "text-light-blue-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-light-blue-200",
    active: "active:opacity-[0.85]",
  },
  blue: {
    border: "border border-blue-500",
    color: "text-blue-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-blue-200",
    active: "active:opacity-[0.85]",
  },
  indigo: {
    border: "border border-indigo-500",
    color: "text-indigo-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-indigo-200",
    active: "active:opacity-[0.85]",
  },
  "deep-purple": {
    border: "border border-deep-purple-500",
    color: "text-deep-purple-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-deep-purple-200",
    active: "active:opacity-[0.85]",
  },
  purple: {
    border: "border border-purple-500",
    color: "text-purple-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-purple-200",
    active: "active:opacity-[0.85]",
  },
  pink: {
    border: "border border-pink-500",
    color: "text-pink-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-pink-200",
    active: "active:opacity-[0.85]",
  },
  red: {
    border: "border border-red-500",
    color: "text-red-500",
    hover: "hover:opacity-75",
    focus: "focus:ring focus:ring-red-200",
    active: "active:opacity-[0.85]",
  },
};

export default buttonOutlined;
